import React from 'react'
import ReactDOM from 'react-dom'
import styled, { createGlobalStyle } from 'styled-components'
import Modal from './components/Modal'

// @ts-ignore
import wallpaper from '/img/wallpaper.jpg'


const Main = () =>  {
    const [isModalOpen, setIsModalOpen] = React.useState(false)

    const closeModal = () => {
      setIsModalOpen(false)
    }

    // React.userEffectはコンポーネントがマウントされた時と、[]の中の変数の状態が更新された時に実行される
    React.useEffect(() => {
      if(isModalOpen === false){
        setTimeout(() => {
          setIsModalOpen(true)
        },1000)
      }
    }, [isModalOpen])

    return(
        <Container>
            <GlobalStyle />
            {/* isModalOpenがtrueの場合は<Modal />を表示、falseの場合はnullを返す */}
            { isModalOpen ? <Modal onDecline={closeModal}/> : null}
        </Container>
    )
}

const GlobalStyle = createGlobalStyle`
  html {
    padding: 0;
    margin: 0;
    height: 100%;
    font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,Segoe UI,Hiragino Kaku Gothic ProN,Hiragino Sans,ヒラギノ角ゴ ProN W3,Arial,メイリオ,Meiryo,sans-serif;
  }

  body {
    background-image: url(${wallpaper});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    padding: 0;
    margin: 0;
    height: 100%;
  }
`
const Container = styled.div`
  text-align: center;
  max-width: 425px;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 12px;
`

ReactDOM.render(<Main />, document.getElementById("container"))
